// Lib
import { createAction } from 'redux-actions';

export const ShowSearch = createAction('SHOW_SEARCH');
export const CloseSearch = createAction('CLOSE_SERACH');
export const UsersSearch = createAction('USERS_SEARCH');
export const UsersSearchResult = createAction('USERS_SEARCH_RESULT');
